var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import CookieHandler from "../Cookies";
var ApiRequestsShoppingCart = /** @class */ (function () {
    function ApiRequestsShoppingCart() {
        var _this = this;
        this.GetProducts = function (dom, baseUri, shoppingcartId, callback) { return __awaiter(_this, void 0, void 0, function () {
            var cookieHandler, $this, encodedShoppingCartId, protocol, host, api, response;
            return __generator(this, function (_a) {
                cookieHandler = new CookieHandler(dom);
                $this = this;
                encodedShoppingCartId = encodeURIComponent(shoppingcartId);
                protocol = window.location.protocol;
                host = window.location.host;
                api = "".concat(baseUri, "/api/shoppingcarts/").concat(encodedShoppingCartId);
                response = fetch(api, {
                    method: "GET",
                    credentials: 'include'
                });
                response.then(function (data) {
                    // Handle 404 - cart no longer exists
                    if (data.status === 404) {
                        // Clear the stale cart cookie
                        cookieHandler.DeleteCookie("shoppingcart");
                        // Return empty cart structure
                        callback(JSON.stringify({
                            itemCount: 0,
                            shoppingcartProductLines: [],
                            totalPrice: 0
                        }));
                        return;
                    }
                    data.text().then(function (json) {
                        callback(json);
                    });
                }).catch(function (error) {
                    console.error('Error fetching shopping cart:', error);
                    callback(JSON.stringify({
                        itemCount: 0,
                        shoppingcartProductLines: [],
                        totalPrice: 0
                    }));
                });
                return [2 /*return*/];
            });
        }); };
        this.GetProductByXPWNumber = function (baseUri, locale, xpwProductNumber, callback) {
        };
        this.QuickOrderSearchRequest = function (_a, callback) {
            var baseUri = _a.baseUri, searchTerm = _a.searchTerm, customerNumber = _a.customerNumber, _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c, _d = _a.limit, limit = _d === void 0 ? 3 : _d;
            return __awaiter(_this, void 0, void 0, function () {
                var api, response;
                return __generator(this, function (_e) {
                    api = "".concat(baseUri, "/api/products/search/quickorder?searchTerm=").concat(searchTerm, "&page=").concat(page, "&limit=").concat(limit, "&exactSearch=true&customerNumber=").concat(customerNumber);
                    response = fetch(api, {
                        method: "GET",
                        credentials: 'include',
                        mode: "cors"
                    });
                    response.then(function (data) {
                        data.text().then(function (json) {
                            callback(json);
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        this.GetItemCount = function (dom, baseUri, shoppingcartId, callback) { return __awaiter(_this, void 0, void 0, function () {
            var cookieHandler, encodedShoppingCartId, protocol, host, api, response;
            return __generator(this, function (_a) {
                cookieHandler = new CookieHandler(dom);
                encodedShoppingCartId = encodeURIComponent(shoppingcartId);
                protocol = window.location.protocol;
                host = window.location.host;
                api = "".concat(baseUri, "/api/shoppingcarts/itemcount/").concat(encodedShoppingCartId);
                response = fetch(api, {
                    method: "GET",
                    credentials: 'include'
                });
                response.then(function (data) {
                    // Handle 404 - cart no longer exists
                    if (data.status === 404) {
                        // Clear the stale cart cookie
                        cookieHandler.DeleteCookie("shoppingcart");
                        // Return zero count
                        callback(JSON.stringify({ count: 0 }));
                        return;
                    }
                    data.text().then(function (json) {
                        callback(json);
                    });
                }).catch(function (error) {
                    console.error('Error fetching item count:', error);
                    callback(JSON.stringify({ count: 0 }));
                });
                return [2 /*return*/];
            });
        }); };
        this.ChangeProductLineAmount = function (dom, baseUri, callback, productLineId, amount) { return __awaiter(_this, void 0, void 0, function () {
            var protocol, host, api, response;
            return __generator(this, function (_a) {
                protocol = window.location.protocol;
                host = window.location.host;
                api = "".concat(baseUri, "/api/shoppingcart_product_lines/").concat(productLineId);
                response = fetch(api, {
                    method: "PUT",
                    credentials: "include",
                    mode: "cors",
                    body: JSON.stringify({
                        amount: new Number(amount)
                    }),
                    headers: {
                        "Content-Type": "application/ld+json",
                        "Access-Control-Allow-Credentials": "true",
                        "Access-Control-Allow-Origin": "http://127.0.0.1:81"
                    },
                });
                response.then(function (data) {
                    data.text().then(function (json) {
                        callback(json);
                    });
                });
                return [2 /*return*/];
            });
        }); };
        this.GetOpenDiscountCodes = function (dom, baseUri, callback) { return __awaiter(_this, void 0, void 0, function () {
            var protocol, host, api, response;
            return __generator(this, function (_a) {
                protocol = window.location.protocol;
                host = window.location.host;
                api = "".concat(baseUri, "/api/discount_codes");
                response = fetch(api, {
                    method: "GET",
                    credentials: 'include'
                });
                response.then(function (r) {
                    r.text().then(function (json) {
                        var j = JSON.parse(json);
                        var openCodes = [];
                        j["hydra:member"].forEach(function (element) {
                            if (!element.ShowInShoppingcart)
                                return;
                            openCodes.push(element);
                        });
                        j["hydra:member"] = openCodes;
                        callback(j);
                    });
                });
                return [2 /*return*/];
            });
        }); };
        this.VerifyDiscountCode = function (dom, baseUri, callback, discountCode, customerNumber) {
            if (customerNumber === void 0) { customerNumber = null; }
            return __awaiter(_this, void 0, void 0, function () {
                var protocol, host, api, response;
                return __generator(this, function (_a) {
                    protocol = window.location.protocol;
                    host = window.location.host;
                    if (customerNumber != null) {
                        api = "".concat(baseUri, "/api/discount_codes/verify/").concat(discountCode, "/?customerNumber=").concat(customerNumber);
                    }
                    else {
                        api = "".concat(baseUri, "/api/discount_codes/verify/").concat(discountCode, "/");
                    }
                    response = fetch(api, {
                        method: "GET",
                        credentials: 'include'
                    });
                    response.then(function (r) {
                        r.text().then(function (json) {
                            callback(JSON.parse(json));
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        this.SelectAddress = function (dom, baseUri, callback, shoppingCartId, addressLocationId) { return __awaiter(_this, void 0, void 0, function () {
            var encodedShoppingCartId, api, response;
            return __generator(this, function (_a) {
                encodedShoppingCartId = encodeURIComponent(shoppingCartId);
                api = "".concat(baseUri, "/api/shoppingcarts/").concat(encodedShoppingCartId);
                response = fetch(api, {
                    method: "PATCH",
                    credentials: 'include',
                    body: JSON.stringify({
                        selectedLocation: addressLocationId
                    }),
                    headers: {
                        "Content-Type": "application/merge-patch+json",
                    },
                });
                response.then(function (r) {
                    r.text().then(function (json) {
                        callback(JSON.parse(json));
                    });
                });
                return [2 /*return*/];
            });
        }); };
        this.GetAddresses = function (dom, baseUri, callback, forXpwCustomerNumber) { return __awaiter(_this, void 0, void 0, function () {
            var encodedCompanyId, protocol, host, api, response;
            return __generator(this, function (_a) {
                encodedCompanyId = encodeURIComponent(forXpwCustomerNumber);
                protocol = window.location.protocol;
                host = window.location.host;
                api = "".concat(baseUri, "/api/transport_locations?forXpwCustomerNumber=").concat(encodedCompanyId);
                response = fetch(api, {
                    method: "GET",
                    credentials: 'include'
                });
                response.catch(function (error) {
                    console.log(error);
                });
                response.then(function (r) {
                    r.text().then(function (json) {
                        callback(JSON.parse(json));
                    });
                });
                return [2 /*return*/];
            });
        }); };
        this.RemoveItemFromShoppingcart = function (dom, baseUri, callback, productLineId) { return __awaiter(_this, void 0, void 0, function () {
            var encodedProductLineId, protocol, host, api, response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        encodedProductLineId = encodeURIComponent(productLineId);
                        protocol = window.location.protocol;
                        host = window.location.host;
                        api = "".concat(baseUri, "/api/shoppingcart_product_lines/").concat(encodedProductLineId);
                        response = fetch(api, {
                            method: "DELETE",
                            credentials: 'include',
                            mode: "cors",
                            headers: {
                                "Content-Type": "application/json",
                            }
                        });
                        _a = callback;
                        return [4 /*yield*/, response];
                    case 1: return [2 /*return*/, _a.apply(void 0, [(_b.sent()).status])];
                }
            });
        }); };
        this.SubmitShoppingCart = function (baseUri, callback, shoppingCartId, orderReference, comment, blanco, addressId, transportMethod, discountCode, isEarlyBird, paymentMethod, deliveryData) {
            if (paymentMethod === void 0) { paymentMethod = 'account'; }
            if (deliveryData === void 0) { deliveryData = null; }
            return __awaiter(_this, void 0, void 0, function () {
                var encodeShoppingCartId, locale, api, requestHeaders, response;
                return __generator(this, function (_a) {
                    encodeShoppingCartId = encodeURIComponent(shoppingCartId);
                    locale = document.documentElement.lang || 'en';
                    api = "".concat(baseUri, "/").concat(locale, "/shoppingcart/submit/");
                    requestHeaders = new Headers();
                    requestHeaders.set('Content-Type', 'application/json');
                    response = fetch(api, {
                        method: "POST",
                        credentials: 'include',
                        mode: "cors",
                        body: JSON.stringify({
                            shoppingCart: encodeShoppingCartId,
                            orderReference: orderReference || "",
                            comment: comment || "",
                            blanco: blanco,
                            addressId: addressId || 0,
                            transportMethod: transportMethod || "pickup",
                            discountCode: discountCode || "",
                            isEarlyBird: isEarlyBird,
                            paymentMethod: paymentMethod || "account",
                            deliveryData: deliveryData || null
                        })
                    });
                    response.then(function (r) {
                        callback(r);
                    });
                    return [2 /*return*/];
                });
            });
        };
        this.ShowProductInfo = function (dom, baseUri, contentHolder, callback, productLineId) { return __awaiter(_this, void 0, void 0, function () {
            var encodedProductLineId, protocol, host, api, response;
            return __generator(this, function (_a) {
                encodedProductLineId = encodeURIComponent(productLineId);
                protocol = window.location.protocol;
                host = window.location.host;
                api = "".concat(baseUri, "/api/shoppingcart_product_lines/productinfo/").concat(encodedProductLineId);
                response = fetch(api, {
                    method: "GET",
                    credentials: "include"
                });
                contentHolder.innerHTML = "";
                response.then(function (data) {
                    data.text().then(function (jsonstring) {
                        var json = JSON.parse(jsonstring);
                        var attributes = json["attributes"]["hydra:member"];
                        for (var i = 0; i < attributes.length; i++) {
                            var attribute = attributes[i];
                            var item = document.createElement("p");
                            item.classList.add("col-12", "col-lg-6", "p-0", "m-0");
                            item.innerHTML = attribute["name"] + ": " + attribute["value"];
                            contentHolder.appendChild(item);
                        }
                        var priceItem = document.createElement("p");
                        priceItem.classList.add("col-12", "col-lg-6", "p-0", "m-0");
                        priceItem.innerHTML = "Price: " + parseFloat(json["price"]).toFixed(2);
                        contentHolder.appendChild(priceItem);
                        var stockItem = document.createElement("p");
                        stockItem.classList.add("col-12", "col-lg-6", "p-0", "m-0");
                        stockItem.innerHTML = "Stock: " + parseFloat(json["stock"]).toFixed(0);
                        contentHolder.appendChild(stockItem);
                    });
                });
                return [2 /*return*/, callback()];
            });
        }); };
        this.AddToShoppingcartWithProductCode = function (dom, baseUri, callback, productId, amount, size) {
            if (size === void 0) { size = 1; }
            return __awaiter(_this, void 0, void 0, function () {
                var cookieHandler, encodedProductId, locale, api, response, _a;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            cookieHandler = new CookieHandler(document);
                            encodedProductId = encodeURIComponent(productId);
                            locale = document.documentElement.lang || 'nl';
                            api = "".concat(baseUri, "/").concat(locale, "/shoppingcart/addproduct/");
                            response = fetch(api, {
                                method: "POST",
                                credentials: 'include',
                                mode: "cors",
                                body: JSON.stringify({
                                    amount: amount,
                                    productcode: encodedProductId,
                                    size: size
                                }),
                                headers: {
                                    "Content-Type": "application/json",
                                },
                            });
                            response.then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                var cookiehandler, data, e_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            cookiehandler = new CookieHandler(document);
                                            if (!(cookieHandler.GetCookie("shoppingcart") == null)) return [3 /*break*/, 4];
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, response.clone().json()];
                                        case 2:
                                            data = _a.sent();
                                            if (data.cartId) {
                                                cookiehandler.SetCookie("shoppingcart", data.cartId, null);
                                            }
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_1 = _a.sent();
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); });
                            _a = callback;
                            return [4 /*yield*/, response];
                        case 1:
                            _a.apply(void 0, [_b.sent()]);
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.AddToShoppingcart = function (dom, baseUri, callback, productId, amount, size) {
            if (size === void 0) { size = 1; }
            return __awaiter(_this, void 0, void 0, function () {
                var cookieHandler, encodedProductId, locale, api, response, _a;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            cookieHandler = new CookieHandler(document);
                            encodedProductId = encodeURIComponent(productId);
                            locale = document.documentElement.lang || 'nl';
                            api = "".concat(baseUri, "/").concat(locale, "/shoppingcart/addproduct/").concat(encodedProductId, "/");
                            response = fetch(api, {
                                method: "POST",
                                credentials: 'include',
                                mode: "cors",
                                body: JSON.stringify({
                                    amount: amount,
                                    size: size
                                }),
                                headers: {
                                    "Content-Type": "application/json",
                                },
                            });
                            response.then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                var cookiehandler, data, e_2;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            cookiehandler = new CookieHandler(document);
                                            if (!(cookieHandler.GetCookie("shoppingcart") == null)) return [3 /*break*/, 4];
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, response.clone().json()];
                                        case 2:
                                            data = _a.sent();
                                            if (data.cartId) {
                                                cookiehandler.SetCookie("shoppingcart", data.cartId, null);
                                            }
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_2 = _a.sent();
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); });
                            _a = callback;
                            return [4 /*yield*/, response];
                        case 1:
                            _a.apply(void 0, [_b.sent()]);
                            return [2 /*return*/];
                    }
                });
            });
        };
    }
    return ApiRequestsShoppingCart;
}());
export default ApiRequestsShoppingCart;
